
import React,{ Component } from 'react';
// import Cards from './components/Cards/Cards';
// import Chart from './components/Chart/Chart';
// import CountryPicker from './components/CountryPicker/CountryPicker';
import styles from './App.module.css';
import { fetchData } from './api';
import {Cards, Chart, CountryPicker} from './components'
import image from './image/covid19.png'

class App extends React.Component{
  state = {
    data: {},
    country: ''
  }

  async componentDidMount (){
       const fetchedData = await fetchData();
       this.setState({data: fetchedData});
  }

  handleCountryChange = async (country) => {
    const data = await fetchData(country);

    this.setState({ data, country: country });
  }

  render(){
    const { data, country } = this.state;
    return(
      <div className={styles.container}>
        <img src={image} className={styles.image} />
        <Cards data={data} />
        <CountryPicker handleCountryChange={this.handleCountryChange} />
        <Chart data={data} country={country} /> 
      </div>
    )
  }
}

export default App;
